<template>
    <span class="share">
        <a v-bind:href="url" @click.prevent="copyToClipboard">
            <span class="material-icons">ios_share</span>
        </a>
        <span v-if="copied" class="lighten" style="margin-left:5px;">Link copied to clipboard</span>
    </span>
</template>

<script>
module.exports = {
    created: function () {

    },
    data:function() {
        return {
            copied:false
        }
    },
    props:{
        url:{type:String}
    },
    methods: {
        copyToClipboard() {
            navigator.clipboard.writeText(this.url).then(() => {
                this.copied = true;
                setTimeout(() => {
                   this.copied = false;
                },1000);
            });
        }
    },
    mounted:function() {

    }
}
</script>
